export const loadClarity = (projectId) => {
  if (typeof window === 'undefined') return
  if (!projectId) return
  if (typeof window.clarity !== 'function') {
    window.clarity = function () {
      (window.clarity.q = window.clarity.q || []).push(arguments)
    }
  }
  window.clarity('consentv2', { ad_Storage: 'granted', analytics_Storage: 'granted' })
  if (window.__clarity_loaded__) return
  const existing = document.querySelector(`script[src="https://www.clarity.ms/tag/${projectId}"]`)
  if (existing) {
    window.__clarity_loaded__ = true
    return
  }
  const s = document.createElement('script')
  s.async = true
  s.src = `https://www.clarity.ms/tag/${projectId}`
  s.crossOrigin = 'anonymous'
  s.onerror = (e) => {
    // eslint-disable-next-line no-console
    console.error('[clarity] load error', e)
  }
  s.onload = () => {
    window.__clarity_loaded__ = true
  }
  document.head.appendChild(s)
}

export const revokeClarity = () => {
  if (typeof window === 'undefined') return

  if (typeof window.clarity === 'function') {
    window.clarity('consentv2', { ad_Storage: 'denied', analytics_Storage: 'denied' })
  }

  const domain = window.location.hostname
  ;['_clck', '_clsk', 'CLID', 'ANONCHK', 'MR', 'MUID', 'SM'].forEach((name) => {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${domain}`
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`
  })

  window.__clarity_loaded__ = false
}

